import { createTheme } from '@mui/material/styles';
import MabryProLight from 'shared/assets/fonts/MabryPro-Light.otf';
import MabryProRegular from 'shared/assets/fonts/MabryPro-Regular.otf';
import MabryProMedium from 'shared/assets/fonts/MabryPro-Medium.otf';
import MabryProBold from 'shared/assets/fonts/MabryPro-Bold.otf';
import Reckless from 'shared/assets/fonts/Reckless-Light.otf';

// Customized color palette and components.
let theme = createTheme({
  // palette: {
  //   background: {
  //     default: '#000',
  //   },
  // },
  typography: {
    fontFamily: [
      'MabryPro',
      'Arial',
    ].join(',')
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: "MabryPro";
          src: url("${MabryProLight}") format("opentype");
          font-weight: 300;
          font-style: normal;
        }

        @font-face {
          font-family: "MabryPro";
          src: url("${MabryProRegular}") format("opentype");
          font-weight: 400;
          font-style: normal;
        }

        @font-face {
          font-family: "MabryPro";
          src: url("${MabryProMedium}") format("opentype");
          font-weight: 500;
          font-style: normal;
        }

        @font-face {
          font-family: "MabryPro";
          src: url("${MabryProBold}") format("opentype");
          font-weight: 700;
          font-style: normal;
        }

        @font-face {
          font-family: "Reckless";
          src: url("${Reckless}") format("opentype");
          font-weight: 300;
          font-style: normal;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap'
        },
      },
    },
  },
});

export default theme;
